import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { SnFormModule } from '@lib/form';
import { TranslationModule } from '@lib/translation';
import { SnButtonModule } from '@lib/ui/button';
import { SnDrawerModule } from '@lib/ui/drawer';
import { SnIconModule } from '@lib/ui/icon';

import { FilterComponent } from './components/filter';
import { SnFilterService } from './services/filter.service';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    MatButtonModule,
    MatIconModule,

    // Libs
    SnDrawerModule,
    SnFormModule,
    TranslationModule,
    SnButtonModule,
    SnIconModule,
  ],
  declarations: [FilterComponent],
  providers: [SnFilterService],
})
export class SnFilterModule {}
